// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1zT8l","col":"CardReaderDesc_col__3M7Pf","label":"CardReaderDesc_label__1mN5a"};